var map = {
	"./cn.json": [
		"33ae",
		"lang-cn-json"
	],
	"./de.json": [
		"0fb2",
		"lang-de-json"
	],
	"./en.json": [
		"0d27"
	],
	"./fr.json": [
		"7e81",
		"lang-fr-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "342c";
module.exports = webpackAsyncContext;